/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Created_ToastInputs */

const en_team_created_toast = /** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team created!`)
};

const es_team_created_toast = /** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Equipo creado!`)
};

const fr_team_created_toast = /** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe créée !`)
};

const de_team_created_toast = /** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team erstellt!`)
};

const id_team_created_toast = /** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim dibuat!`)
};

/** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */
const ja_team_created_toast = en_team_created_toast;

/** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */
const zh_team_created_toast = en_team_created_toast;

/** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */
const ar_team_created_toast = en_team_created_toast;

/** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */
const it_team_created_toast = en_team_created_toast;

/** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */
const ru_team_created_toast = en_team_created_toast;

/** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */
const pt_team_created_toast = en_team_created_toast;

/** @type {(inputs: Team_Created_ToastInputs) => LocalizedString} */
const ko_team_created_toast = en_team_created_toast;

/**
* | output |
* | --- |
* | "Team created!" |
*
* @param {Team_Created_ToastInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_created_toast = /** @type {((inputs?: Team_Created_ToastInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Created_ToastInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_created_toast(inputs)
	if (locale === "es") return es_team_created_toast(inputs)
	if (locale === "fr") return fr_team_created_toast(inputs)
	if (locale === "de") return de_team_created_toast(inputs)
	if (locale === "ja") return ja_team_created_toast(inputs)
	if (locale === "zh") return zh_team_created_toast(inputs)
	if (locale === "ar") return ar_team_created_toast(inputs)
	if (locale === "id") return id_team_created_toast(inputs)
	if (locale === "it") return it_team_created_toast(inputs)
	if (locale === "ru") return ru_team_created_toast(inputs)
	if (locale === "pt") return pt_team_created_toast(inputs)
	return ko_team_created_toast(inputs)
});